import { BankPortalAuthService } from './../../../core/services/bankportal-auth.service';
import { Component, OnInit} from '@angular/core';

import * as moment from 'moment';

import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { BankPortalService, DeployedHistoryViewModel, PosHistoryViewModel } from '../../../web-api-client';
import { PosHistory } from '../../../core/models/posHistory/pos-history.model';
import "ag-grid-angular";
import { Permission } from '../../../auth/permissions';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'bankportal-reconfigure',
  templateUrl: './reconfigure-request.component.html',
  //styleUrls: ['./bankportal-details.component.css']
})
export class BankReconfigureComponent implements OnInit {
  rowsHistoryCache: PosHistory[] = []; 
  rowsHistory: PosHistory[] = [];
  rowsHistoryCache1: PosHistory[] = [];
  historyEdit:PosHistoryViewModel = new PosHistoryViewModel();
  editRow = new PosHistoryViewModel();
  merchantName!: string;
  idTer!: string;
  idMer!: string;
  loadingIndicator!: boolean;
  showModelBox: boolean = false;
  columnDefs: any[] = [];
  columns: any[] = [];
  rows: DeployedHistoryViewModel[] = [];
  roworiginal: DeployedHistoryViewModel[] = [];
  rowsCache: DeployedHistoryViewModel[] = [];
  rowsHistory1: PosHistory[] = [];
  submitted: boolean = false;
  reconfigureForm!: UntypedFormGroup;
  isReqSave: boolean = false;

  connectivityList = [
    { value: 1, option: 'ETHERNET' },
    { value: 2, option: 'GPRS' },
    { value: 3, option: 'PSTN' },
    { value: 4, option: 'UNKNOWN' },
    { value: 5, option: 'WIFI' }
];
  gridApi: any;
  gridColumnApi: any;
  quickSearchValue: any;

  constructor(private formBuilder: UntypedFormBuilder,
    private _toastr: ToastrService,
    private bankPortalService: BankPortalService,
    private bankPortalAuthService: BankPortalAuthService) {
  }


  ngOnInit() {
    this.hide();
    this.columnDefs = [
      {
        headerName: 'Deployed Date', field: 'deployDate', valueFormatter: (data) => moment(data.value).format('ll'), width: 128, suppressSizeToFit: true, filter: 'date',
        filterParams: {
          comparator: function (filterLocalDateAtMidnight, cellValue) {
            //using moment js
            var dateAsString = moment(cellValue).format('DD/MM/YYYY');
            var dateParts = dateAsString.split("/");
            var cellDate = new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]));
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            }

            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
          }
        }
      },
      { headerName: 'Merchant', field: 'merchant', width: 250, suppressSizeToFit: true },
      { headerName: 'Terminal ID', field: 'idTerminal', width: 150, suppressSizeToFit: true},
      { headerName: 'Merchant ID', field: 'idMerchant', width: 150, suppressSizeToFit: true },
      { headerName: 'Address', field: 'address', width: 180, suppressSizeToFit: true },
      { headerName: 'District', field: 'district', width: 130, suppressSizeToFit: true },
      { headerName: 'Province', field: 'province', width: 150, suppressSizeToFit: true },
      { headerName: 'Model', field: 'item', width: 140, suppressSizeToFit: true },
      { headerName: 'Serial Number', field: 'serialKey', width: 250, suppressSizeToFit: true },
      { headerName: 'Application Date', field: 'applicationFormat', width: 180, suppressSizeToFit: true },
      { headerName: 'Connectivity', field: 'connectivity', width: 150, suppressSizeToFit: true, cellRenderer: this.connectivityType(this.connectivityList) },
      { headerName: 'Deployed Location', field: 'merchantLocation', width: 180, suppressSizeToFit: true },
      { headerName: 'Contact Person', field: 'contactPerson', width: 150, suppressSizeToFit: true },
      { headerName: 'Contact No', field: 'contactNo1', width: 150, suppressSizeToFit: true },
      
      // { headerName: 'Email Address', field: 'outlet', width: 150, suppressSizeToFit: true},

    ];
    this.columnDefs.push({
      headerName: "Actions",
      suppressMenu: true,
      field: 'requestName',
      suppressSorting: true,
      width: 250,
      cellRenderer: this.actions(this.bankPortalAuthService),

    });
    this.loadPosHistorysData();
    this.reconfigureForm = this.formBuilder.group({
      component1: ['', [Validators.required]],
      component2: ['', [Validators.required]],
      kvc1: ['', [Validators.required]],
      kvc2: ['', Validators.required],
      combineValue: [''],
      finalValue: ['', Validators.required],
      terminalType: ['', Validators.required],
      remarksDeploy: ['', Validators.required]

    });

  }
  public actions(bankPortalAuthService: BankPortalAuthService) {
    return function (params: any) {
      if (bankPortalAuthService.hasPermission(Permission.ReconfigureRequest)) {
        if (params.data.requestName != "RemoveRequest" && params.data.statusName == "DeployedVerified") {

          return (`<button type= "button btn-primary btn-sm"  data-action-type="Remove"  class="btn-req btn-sm">Replace Terminal </button> `);
        }
      }
      else if (params.data.requestName == "Reconfigure" && params.data.statusName != "DeployedVerified") {
        return (`<span style="background-color:green;color:white;font-size: 120%;">Requested for Reconfigure </span>`);
      }

      else {
        return null;
      }
    }
  };
  public onRowClicked(e) {
    if (e.event.target !== undefined) {
      let data = e.data;

      let actionType = e.event.target.getAttribute("data-action-type");

      switch (actionType) {
        case "Remove":
          return this.RemoveSelect(data);

      }
    }
  }
  public serial(params) {
    var temp = params.data.serialKey;
    var newtemp = temp.substring(0, temp.length - 1);
    return newtemp;
  }
  public merchantId(params) {
    var temp = params.data.idMerchant;
    var newtemp = temp.substring(0, temp.length - 1);
    return newtemp;
  }
  public termId(params) {
    var temp = params.data.idTerminal;
    var newtemp = temp.substring(0, temp.length - 1);
    return newtemp;
  }
  public contactNo(params) {
    var temp = params.data.contactNo1;
    var newtemp = temp.substring(0, temp.length - 1);
    return newtemp;
  }
  private RemoveSelect(row: PosHistoryViewModel) {
    this.addRemove(row);

  }


  get f() {
    return this.reconfigureForm.controls;
  }


  addRemove(row: PosHistoryViewModel) {
    // this.alertService.showDialog('Are you sure, you want  remove this   \"' + row.serialKey + '\"     removed  from  \"' + row.merchant + '\"  ?', DialogType.confirm, () => this.removeHelper(row));
    // var txt;
    var r = confirm("Are you sure, you want  reconfigure this " + row.serialKey + " from " + row.merchant + " ?");
    if (r == true) {
      this.removeHelper(row)
    } else {

    }
  }
  removeHelper(row: PosHistoryViewModel) {
    // this.alertService.startLoadingMessage("Requesting...");
    this.loadingIndicator = true;
    this.editRow = row;

    this.historyEdit = row;
    this.trimData(row);
    this.showModelBox = true;

  }
  saveReconfigure() {
    this.submitted = true;
    if (this.reconfigureForm.invalid)
      return;
    this.isReqSave = true;

    if(this.historyEdit.id){
    this.bankPortalService.bankPortal_ReplacementRequestById(this.historyEdit.id,this.historyEdit).subscribe(
        res => {
        this._toastr.success("Reconfigure Request Successfully Created", "Success");
        this.editRow = new PosHistoryViewModel();
        this.submitted = false;
        this.historyEdit = new PosHistoryViewModel();
        this.showModelBox = false;
        this.isReqSave = false;
        this.reconfigureForm.reset;
        this.loadPosHistorysData();

      },
        error => {
          console.log(error);

        },
        () => {
          this.isReqSave = false;
        });
      }
  }

  public trimData(params) {
    var temp = this.editRow.idTerminal!;
    var temp1 = this.editRow.idMerchant!;

    this.idTer = temp.substring(0, temp.length - 1);
    this.idMer = temp1.substring(0, temp1.length - 1);



  }




  loadPosHistorysData() {
    // this.alertService.startLoadingMessage();
    this.loadingIndicator = true;
    this.bankPortalService.bankPortal_GetHistory().subscribe(results => 
      this.onDataLoadSuccessful(results), 
      error => this.onDataLoadFailed(error));
  }


  onDataLoadSuccessful(posHistorys: DeployedHistoryViewModel[]) {
    // this.alertService.stopLoadingMessage();
    this.loadingIndicator = false;

    posHistorys.forEach((posHistory, index, posHistorys) => {
      (<any>posHistory).index = index + 1;
    });
    this.rowsCache = [...posHistorys];
    this.rows = posHistorys;
    this.roworiginal = this.rows;
  }


  onDataLoadFailed(error: any) {
    // this.alertService.stopLoadingMessage();
    this.loadingIndicator = false;
    this._toastr.error(`Unable to retrieve users from the server`,"Load Error");
  }
  onSearchChanged(value: string) {
    // this.rows = this.rowsCache.filter(r => Utilities.searchArray(value, false, r.merchant, r.idMerchant, r.idTerminal, r.item, r.address, r.contactPerson, r.serialKey));
  }
  open() {
    this.showModelBox = true;
  }
  hide() {
    this.showModelBox = false;
    this.submitted = false;
    this.isReqSave = false;
  }

  CallBackSupport($event) {
    var data = $event.SupportData;
    //console.log(data);
    this.showModelBox = false;
  }
  gridOptions = {
    rowSelection: 'multiple',
    enableSorting: 'true',
    enableColResize: 'true',
    enableRtl: 'true',
    pagination: 'true',
    paginationAutoPageSize: 'true',
    animateRows: 'true',
    rowClicked: 'true'
  }

onModelUpdated() {
setTimeout(() => { this.gridColumnApi.autoSizeAllColumns() });
}

onGridReady(params: any) {
  this.gridApi = params.api;
  this.gridColumnApi = params.columnApi;
  this.gridApi.showLoadingOverlay();
}

onQuickFilterChanged(){
  this.gridApi.setQuickFilter(this.quickSearchValue)
}
  public connectivityType(connectivityList) {
    return function action(params) {
      if (params.data.connectivities != null) {
        var idString = params.data.connectivities.toString();
        let ids = idString.split(",");
        ids = ids.map(x => +x);
        var temp = connectivityList.filter((f: { value: any; }) => ids.includes(f.value));
        var temp1 = temp.map(x => x.option).join();
        return temp1;
      }
      else {
        return params.data.connectivities;
      }
    }
  }
}
